import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AskExpartService {
  isOpen = signal<boolean>(false);
  private iframeReloadSubject = new BehaviorSubject<string>(''); // holds the latest iframe URL
  iframeReload$ = this.iframeReloadSubject.asObservable();
  webToken$ = this.iframeReloadSubject.asObservable();

  setIframeUrl(newUrl: string) {
    this.iframeReloadSubject.next(newUrl);
  }

  triggerIframeReload(context: string) {
    this.iframeReloadSubject.next(context);
  }

  toggle() {
    this.isOpen.set(!this.isOpen());
  }

  close() {
    this.isOpen.set(false);
  }

  open() {
    this.isOpen.set(true);
  }
}
